module.exports = __webpack_public_path__ + "static/16-b0dcff35feb2b63cb246715ccb27dc40.png";